import React from "react";
import { AddSimpleWorkflowFieldDrawer } from "./AddSimpleWorkflowFieldDrawer";
import { AddGeneralWorkflowFieldDrawer } from "./AddGeneralWorkflowFieldDrawer";
import { QuestionnaireType } from "@/components/controls/Questionnaires/Questionnaire";

interface AddWorkflowFieldDrawerProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  workflowType: QuestionnaireType;
  questionnaireId: string;
  forceChecklistItem?: boolean;
  enableAutofill?: boolean;
  onSave?: (fieldData: any) => void;
}

export const AddWorkflowFieldDrawer: React.FC<AddWorkflowFieldDrawerProps> = ({
  isOpen,
  onOpenChange,
  workflowType,
  questionnaireId,
  forceChecklistItem,
  enableAutofill = true,
  onSave
}) => {
  if (
    workflowType === QuestionnaireType.GENERAL ||
    workflowType === QuestionnaireType.POC
  ) {
    return (
      <AddGeneralWorkflowFieldDrawer
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        questionnaireId={questionnaireId}
        forceChecklistItem={forceChecklistItem}
        enableAutofill={enableAutofill}
        onSave={onSave}
      />
    );
  }

  return (
    <AddSimpleWorkflowFieldDrawer
      workflowType={workflowType}
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      questionnaireId={questionnaireId}
      enableAutofill={enableAutofill}
      onSave={onSave}
    />
  );
};
